import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQrCode = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 2.91667V1.75",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33333 7H7.58333C7.26133 7 7 6.73867 7 6.41667V5.25",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.33333 7H1.75",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75 10.5H7.58333C7.26133 10.5 7 10.7613 7 11.0833V12.25",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 8.75H10.5",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.25 8.75V11.6667C12.25 11.9887 11.9887 12.25 11.6667 12.25H8.75",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.08334 7H5.25001",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.66667 5.25H2.33333C2.01133 5.25 1.75 4.98867 1.75 4.66667V2.33333C1.75 2.01133 2.01133 1.75 2.33333 1.75H4.66667C4.98867 1.75 5.25 2.01133 5.25 2.33333V4.66667C5.25 4.98867 4.98867 5.25 4.66667 5.25Z",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.66667 12.25H2.33333C2.01133 12.25 1.75 11.9887 1.75 11.6667V9.33333C1.75 9.01133 2.01133 8.75 2.33333 8.75H4.66667C4.98867 8.75 5.25 9.01133 5.25 9.33333V11.6667C5.25 11.9887 4.98867 12.25 4.66667 12.25Z",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.6667 5.25H9.33333C9.01133 5.25 8.75 4.98867 8.75 4.66667V2.33333C8.75 2.01133 9.01133 1.75 9.33333 1.75H11.6667C11.9887 1.75 12.25 2.01133 12.25 2.33333V4.66667C12.25 4.98867 11.9887 5.25 11.6667 5.25Z",
			stroke: "#1F2937",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.18851 3.18558C3.28211 3.09199 3.39968 3.05664 3.49999 3.05664C3.60029 3.05664 3.71786 3.09199 3.81146 3.18558C3.90506 3.27918 3.9404 3.39676 3.9404 3.49706C3.9404 3.59736 3.90506 3.71493 3.81146 3.80853C3.71786 3.90213 3.60029 3.93747 3.49999 3.93747C3.39968 3.93747 3.28211 3.90213 3.18851 3.80853C3.09492 3.71493 3.05957 3.59736 3.05957 3.49706C3.05957 3.39676 3.09492 3.27918 3.18851 3.18558ZM3.80723 3.8043C3.89981 3.71173 3.93457 3.59561 3.93457 3.49706C3.93457 3.39851 3.89981 3.28239 3.80723 3.18981C3.71466 3.09724 3.59854 3.06247 3.49999 3.06247C3.40143 3.06247 3.28532 3.09724 3.19274 3.18981C3.10017 3.28239 3.0654 3.39851 3.0654 3.49706C3.0654 3.59561 3.10017 3.71173 3.19274 3.8043C3.28532 3.89688 3.40143 3.93164 3.49999 3.93164C3.59854 3.93164 3.71466 3.89688 3.80723 3.8043Z",
			fill: "#1F2937"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.93457 3.49706C3.93457 3.59561 3.89981 3.71173 3.80723 3.8043C3.71466 3.89688 3.59854 3.93164 3.49999 3.93164C3.40143 3.93164 3.28532 3.89688 3.19274 3.8043C3.10017 3.71173 3.0654 3.59561 3.0654 3.49706C3.0654 3.39851 3.10017 3.28239 3.19274 3.18981C3.28532 3.09724 3.40143 3.06247 3.49999 3.06247C3.59854 3.06247 3.71466 3.09724 3.80723 3.18981C3.89981 3.28239 3.93457 3.39851 3.93457 3.49706Z",
			fill: "#1F2937"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1857 3.18847C10.2792 3.09491 10.3968 3.05957 10.4971 3.05957C10.5974 3.05957 10.715 3.09492 10.8086 3.18856C10.9022 3.28218 10.9375 3.39975 10.9375 3.49999C10.9375 3.60023 10.9022 3.7178 10.8086 3.81142C10.715 3.90505 10.5974 3.9404 10.4971 3.9404C10.3968 3.9404 10.2792 3.90506 10.1857 3.8115C10.0921 3.71793 10.0567 3.60035 10.0567 3.49999C10.0567 3.39962 10.0921 3.28205 10.1857 3.18847ZM10.8043 3.80727C10.8969 3.71472 10.9317 3.5986 10.9317 3.49999C10.9317 3.40137 10.8969 3.28525 10.8043 3.1927C10.7117 3.10016 10.5956 3.0654 10.4971 3.0654C10.3985 3.0654 10.2824 3.10017 10.1898 3.19278C10.0972 3.28538 10.0625 3.4015 10.0625 3.49999C10.0625 3.59848 10.0972 3.71459 10.1898 3.80719C10.2824 3.8998 10.3985 3.93457 10.4971 3.93457C10.5956 3.93457 10.7117 3.89981 10.8043 3.80727Z",
			fill: "#1F2937"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9317 3.49999C10.9317 3.5986 10.8969 3.71472 10.8043 3.80727C10.7117 3.89981 10.5956 3.93457 10.4971 3.93457C10.3985 3.93457 10.2824 3.8998 10.1898 3.80719C10.0972 3.71459 10.0625 3.59848 10.0625 3.49999C10.0625 3.4015 10.0972 3.28538 10.1898 3.19278C10.2824 3.10017 10.3985 3.0654 10.4971 3.0654C10.5956 3.0654 10.7117 3.10016 10.8043 3.1927C10.8969 3.28525 10.9317 3.40137 10.9317 3.49999Z",
			fill: "#1F2937"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.769 6.68847C10.8626 6.59491 10.9801 6.55957 11.0804 6.55957C11.1807 6.55957 11.2983 6.59492 11.3919 6.68856C11.4855 6.78218 11.5208 6.89975 11.5208 6.99999C11.5208 7.10023 11.4855 7.2178 11.3919 7.31142C11.2983 7.40505 11.1807 7.4404 11.0804 7.4404C10.9801 7.4404 10.8626 7.40507 10.769 7.3115C10.6754 7.21793 10.64 7.10035 10.64 6.99999C10.64 6.89962 10.6754 6.78205 10.769 6.68847ZM11.3876 7.30727C11.4802 7.21472 11.515 7.0986 11.515 6.99999C11.515 6.90137 11.4802 6.78525 11.3876 6.6927C11.2951 6.60016 11.179 6.5654 11.0804 6.5654C10.9819 6.5654 10.8657 6.60017 10.7731 6.69278C10.6806 6.78538 10.6458 6.9015 10.6458 6.99999C10.6458 7.09848 10.6806 7.21459 10.7731 7.30719C10.8657 7.3998 10.9819 7.43457 11.0804 7.43457C11.179 7.43457 11.2951 7.39982 11.3876 7.30727Z",
			fill: "#1F2937"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.515 6.99999C11.515 7.0986 11.4802 7.21472 11.3876 7.30727C11.2951 7.39982 11.179 7.43457 11.0804 7.43457C10.9819 7.43457 10.8657 7.3998 10.7731 7.30719C10.6806 7.21459 10.6458 7.09848 10.6458 6.99999C10.6458 6.9015 10.6806 6.78538 10.7731 6.69278C10.8657 6.60017 10.9819 6.5654 11.0804 6.5654C11.179 6.5654 11.2951 6.60016 11.3876 6.6927C11.4802 6.78525 11.515 6.90137 11.515 6.99999Z",
			fill: "#1F2937"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1857 10.1884C10.2793 10.0949 10.3969 10.0596 10.4971 10.0596C10.5973 10.0596 10.7149 10.0949 10.8086 10.1885C10.9022 10.2821 10.9375 10.3997 10.9375 10.5C10.9375 10.6002 10.9022 10.7178 10.8086 10.8115C10.7149 10.9051 10.5973 10.9404 10.4971 10.9404C10.3969 10.9404 10.2793 10.9051 10.1857 10.8115C10.0921 10.718 10.0567 10.6004 10.0567 10.5C10.0567 10.3996 10.0921 10.282 10.1857 10.1884ZM10.8042 10.8073C10.8969 10.7148 10.9317 10.5986 10.9317 10.5C10.9317 10.4014 10.8969 10.2852 10.8042 10.1927C10.7117 10.1001 10.5956 10.0654 10.4971 10.0654C10.3986 10.0654 10.2825 10.1001 10.1898 10.1927C10.0972 10.2854 10.0625 10.4015 10.0625 10.5C10.0625 10.5985 10.0972 10.7146 10.1898 10.8072C10.2825 10.8998 10.3986 10.9346 10.4971 10.9346C10.5956 10.9346 10.7117 10.8999 10.8042 10.8073Z",
			fill: "#1F2937"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9317 10.5C10.9317 10.5986 10.8969 10.7148 10.8042 10.8073C10.7117 10.8999 10.5956 10.9346 10.4971 10.9346C10.3986 10.9346 10.2825 10.8998 10.1898 10.8072C10.0972 10.7146 10.0625 10.5985 10.0625 10.5C10.0625 10.4015 10.0972 10.2854 10.1898 10.1927C10.2825 10.1001 10.3986 10.0654 10.4971 10.0654C10.5956 10.0654 10.7117 10.1001 10.8042 10.1927C10.8969 10.2852 10.9317 10.4014 10.9317 10.5Z",
			fill: "#1F2937"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.19149 10.1885C3.28511 10.0949 3.40267 10.0596 3.50292 10.0596C3.60316 10.0596 3.72073 10.0949 3.81435 10.1885C3.90798 10.2821 3.94333 10.3997 3.94333 10.5C3.94333 10.6003 3.90798 10.7179 3.81435 10.8115C3.72073 10.9051 3.60316 10.9404 3.50292 10.9404C3.40267 10.9404 3.28511 10.9051 3.19149 10.8115C3.09785 10.7179 3.0625 10.6003 3.0625 10.5C3.0625 10.3997 3.09785 10.2821 3.19149 10.1885ZM3.81012 10.8073C3.90273 10.7147 3.9375 10.5985 3.9375 10.5C3.9375 10.4014 3.90273 10.2853 3.81012 10.1927C3.71752 10.1001 3.60141 10.0654 3.50292 10.0654C3.40442 10.0654 3.28831 10.1001 3.19571 10.1927C3.1031 10.2853 3.06833 10.4014 3.06833 10.5C3.06833 10.5985 3.1031 10.7147 3.19571 10.8073C3.28831 10.8998 3.40442 10.9346 3.50292 10.9346C3.60141 10.9346 3.71752 10.8998 3.81012 10.8073Z",
			fill: "#1F2937"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.9375 10.5C3.9375 10.5985 3.90273 10.7147 3.81012 10.8073C3.71752 10.8998 3.60141 10.9346 3.50292 10.9346C3.40442 10.9346 3.28831 10.8998 3.19571 10.8073C3.1031 10.7147 3.06833 10.5985 3.06833 10.5C3.06833 10.4014 3.1031 10.2853 3.19571 10.1927C3.28831 10.1001 3.40442 10.0654 3.50292 10.0654C3.60141 10.0654 3.71752 10.1001 3.81012 10.1927C3.90273 10.2853 3.9375 10.4014 3.9375 10.5Z",
			fill: "#1F2937"
		})
	]
});
const ForwardRef = forwardRef(SvgQrCode);
export default ForwardRef;
